import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ReportIcon from '@mui/icons-material/Report';
import { Box, Chip, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';

const ProductReportListItem = ({ report, canMutate, onEdit, onDelete }) => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 2,
      p: 1.5,
      display: 'flex',
      gap: 1.5,
      alignItems: 'center',
      bgcolor: 'grey.50',
    }}
  >
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
      >
        <Typography fontWeight={500} noWrap>
          {report.title}
        </Typography>
        <Chip
          size="small"
          label={`تعداد: ${report.quantity ?? 0}`}
          color="default"
          variant="filled"
        />
      </Stack>

      {report.description ? (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mt: 0.5,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {report.description}
        </Typography>
      ) : null}
    </Box>

    {canMutate ? (
      <Stack direction="row" gap={0.25} flexShrink={0}>
        <IconButton
          size="small"
          color="info"
          onClick={() => onEdit(report)}
          aria-label="ویرایش"
        >
          <EditIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          color="error"
          onClick={() => onDelete(report)}
          aria-label="حذف"
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Stack>
    ) : null}
  </Box>
);

export default ProductReportListItem;
